"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsView = void 0;
var react_1 = __importStar(require("react"));
var utils_1 = require("../../utils");
var use_analytics_1 = require("../lib/use-analytics");
function AnalyticsView(props) {
    return (
    // Need to force the component to unmount when the name changes
    react_1.default.createElement(AnalyticsInnerView, __assign({ key: props.name }, props)));
}
exports.AnalyticsView = AnalyticsView;
// children must be 1 element and must be either be a DOM node or a component that forwards refs
function AnalyticsInnerView(_a) {
    var name = _a.name, children = _a.children, properties = _a.properties, _b = _a.options, _c = _b === void 0 ? {
        viewTimeout: 2000,
        intersectionThreshold: 0.2,
    } : _b, _d = _c.viewTimeout, viewTimeout = _d === void 0 ? 2000 : _d, _e = _c.intersectionThreshold, intersectionThreshold = _e === void 0 ? 0.2 : _e;
    var intersectionObserverExists = typeof window !== 'undefined' && 'IntersectionObserver' in window;
    var dispatch = (0, use_analytics_1.useAnalytics)().dispatch;
    var domNodeRef = (0, react_1.useRef)(null);
    var domNodeSeenRef = (0, react_1.useRef)(false);
    var timeoutRef = (0, react_1.useRef)();
    var observerRef = (0, utils_1.useLazyRef)(function () {
        if (intersectionObserverExists) {
            return new IntersectionObserver(
            // Only observing one node
            function (_a, observer) {
                var entry = _a[0];
                var isIntersecting = entry.isIntersecting, target = entry.target;
                if (isIntersecting) {
                    timeoutRef.current = setTimeout(function () {
                        dispatch({ type: 'view', name: name, properties: properties });
                        domNodeSeenRef.current = true;
                        observer.unobserve(target);
                    }, viewTimeout);
                }
                else {
                    timeoutRef.current && clearTimeout(timeoutRef.current);
                }
            }, {
                root: null,
                threshold: intersectionThreshold, // Percentage of DOM that should be visible
            });
        }
        return null;
    });
    var setRef = (0, react_1.useCallback)(function (node) {
        // !observerRef.current happens when IntersectionObserver is not supported
        if (!observerRef.current || domNodeSeenRef.current) {
            return;
        }
        if (domNodeRef.current) {
            observerRef.current.unobserve(domNodeRef.current);
            timeoutRef.current && clearTimeout(timeoutRef.current);
        }
        domNodeRef.current = node;
        if (domNodeRef.current) {
            observerRef.current.observe(domNodeRef.current);
        }
    }, [observerRef]);
    // This is difficult to type correctly
    var child = react_1.Children.only(children);
    var mergedRef = (0, utils_1.mergeRefs)(child.ref, setRef);
    (0, react_1.useEffect)(function () {
        if (!intersectionObserverExists) {
            timeoutRef.current = setTimeout(function () {
                dispatch({ type: 'view', name: name, properties: properties });
            }, viewTimeout);
        }
        return function () {
            timeoutRef.current && clearTimeout(timeoutRef.current);
        };
    }, [name]);
    return (0, react_1.cloneElement)(child, { ref: mergedRef });
}
